import ReportMenu from "@domains/common/views/components/ReportMenu/ReportMenu";

import * as S from "./CommentOtherMenuBottomSheet.style";

interface CommentOtherMenuBottomSheetProps {
  commentType: "COMMENT" | "REPLY";
  targetId: number;
}

const CommentOtherMenuBottomSheet = ({
  commentType,
  targetId,
}: CommentOtherMenuBottomSheetProps) => {
  return (
    <S.BottomSheetContainer>
      <ReportMenu type={commentType} targetId={targetId} />
    </S.BottomSheetContainer>
  );
};

export default CommentOtherMenuBottomSheet;
